
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { UserProfileFormDto } from "@/types/user.type";
import UserService from "@/services/user.service";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

interface IImageRef extends Element {
  $el: {
    childNodes: HTMLElement[]
  }
}

@Component
export default class UserEditModalComponent extends Mixins(ValidatedFormMixin) {
  @Prop() modalShow!: boolean;
  @Prop() id!: number;

  form: UserProfileFormDto | null = null;
  profileFile: File | null = null;

  loading = false;

  get initials(): string {
    if (!this.form || !this.form.firstName || !this.form.lastName) {
      return "";
    }

    return this.form.firstName[0] + this.form.lastName[0];
  }

  async mounted(): Promise<void> {
    this.loading = true;
    this.form = await UserService.getFormAsync(this.id);
    this.loading = false;
  }

  onUploadClick(): void {
    (this.$refs.image as IImageRef).$el.childNodes[0].click()
  }

  base64Encode(data: File): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = () => resolve(reader.result as string);
    });
  }

  @Watch('profileFile')
  onProfileFileChanged(newValue: File): void {
    this.base64Encode(newValue)
      .then(value => {
        if (!this.form) {
          return;
        }

        this.form.profileUrl = null;
        this.form.profileData = value;
      }
    );
  }

  async update(): Promise<void> {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        try {
          if (!this.form) {
            return;
          }

          await UserService.updateAsync(this.form);

          this.form.profileData = null;
          this.form.profileUrl = null;
        }
        catch {
          this.loading = false;
          return;
        }
        await this.$store.dispatch("Auth/storeUserInfo");
        this.$emit("success");
        this.loading = false;
        this.$emit('update:modalShow', false);
      }
    });
  }

  closeModal(): void {
    this.$emit('update:modalShow', false);
  }
}
